<template>
  <div class="draggableContainer">
    <Draggable
      v-for="(widget, key) in widgets"
      :key="key"
      v-if="~widgetsInEditMode.indexOf(widget['.key'])"
      :widget="widget"
      />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import Draggable from './Draggable'

export default {
  props: ['widgets'],
  components: {
    Draggable
  },
  computed: {
    ...mapState([
      'widgetsInEditMode'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WidgetsEdit/index.vue